import { useContext, useEffect, useState } from "react";
import { RouteContext } from "../../contexts/RoutesContext";
import { useSearchParams } from "react-router";
import { Card } from "../components/Shared/Card";
import { Colour } from "../Variables";
import { PasswordResetForm } from "../components/Forms/PasswordResetForm";
import { LoadingContent } from "../components/Shared/LoadingContent";
import { API_CheckPasswordRequestID, PasswordResetRequestModel } from "../../apis/ApisAuth";

export function ChangePassword() {
    const routeContext = useContext(RouteContext);
    const [queryParameters] = useSearchParams();
    const [loading, setLoading] = useState<boolean>(true);
    const [passwordResetRequestModel, setPasswordResetRequestModel] = useState<PasswordResetRequestModel>(null);

    let id: string = queryParameters.get("g");

    const checkID = async () => {
        var res = await API_CheckPasswordRequestID(id);
        setLoading(false);
        setPasswordResetRequestModel(res);
    }

    useEffect(() => {
        routeContext.setRoutes([{ name: "Change password", route: null }])
        checkID();
    }, []);

    return (
        <>
            <Card headerClasses="" title="Change password" headerTheme={Colour.Secondary}>
                <LoadingContent classes="w-100" loading={loading}>
                    <PasswordResetForm uid={id} data={passwordResetRequestModel} />
                </LoadingContent>
            </Card>
        </>
    );
}